
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-container",
      function () {
        return require("private-next-pages/material-ui/react-container.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-container"])
      });
    }
  